import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import { EmployeeProfile, ProfileNotice, profileTabs } from "@/features/employee/profile";

// The profile card around every tab. Tabs are child routes, so each has a link. An id
// that is not on this team comes back as null from employees.get and EmployeeProfile
// says so; the error page is only for a profile that failed to load.
export const Route = createFileRoute("/_app/_main/team/$employeeId")({
  component: Profile,
  errorComponent: () => <ProfileNotice text="This profile didn't load. Reload the page to try again." />,
});

function Profile() {
  const { employeeId } = Route.useParams();
  const tab = useRouterState({
    select: (state) => profileTabs.find((item) => state.location.pathname.endsWith(`/${item.key}`))?.key,
  });
  return (
    <EmployeeProfile employeeId={employeeId as Id<"employees">} tab={tab}>
      <Outlet />
    </EmployeeProfile>
  );
}
